export const RolloutPlan = {
  ENTERPRISE: 30,
  PROFESSIONAL: 20,
  FREE: 10,
} as const;

export type RolloutPlanKeys = keyof typeof RolloutPlan;
export type RolloutPlanValues = typeof RolloutPlan[RolloutPlanKeys];

export const getRolloutPlanNames = () => {
  return Object.keys(RolloutPlan);
}

export const getRolloutPlanByValue = (value: RolloutPlanValues) => {
  return Object.keys(RolloutPlan).find(role => RolloutPlan[role as RolloutPlanKeys] === value);
}

export const freePlanClientLimit = 50;